// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"FormActions_buttonsWrapper__ZKQt1","buttonWrapper":"FormActions_buttonWrapper__czzpB"};